<script lang="ts" setup>
import InlineSvg from 'vue-inline-svg'
import { computed } from 'vue'
import useMe from '@helm/composables/queries/me'
import MainNavMenu from '@helm/layouts/components/MainNavMenu.vue'
import MainNavMobile from '@helm/layouts/components/MainNavMobile.vue'
import SideNavMobile from '@helm/layouts/components/SideNavMobile.vue'
import SideNavMenu from '@helm/layouts/components/SideNavMenu.vue'
import { useRoute } from 'vue-router'
import { get, upperFirst } from 'lodash'
import type { SideNavLocation } from '@helm/types/sideNav'
import logoIcon from '@/assets/images/logo-icon.svg'
import logo from '@/assets/images/logo.svg'
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import useUtils from '@/store/utils'
import ENV from '@/constants/env'

const route = useRoute()
const sideNav = computed(() => get(route.meta, `props.sideNav`) as SideNavLocation | undefined)

const utils = useUtils()
const mobile = computed(() => utils.getMaxWidth(`md`))
const environment = computed(() => (ENV.environment === `production` ? `` : ` ${upperFirst(ENV.environment)}`))

const { isSuccess, name } = useMe()
</script>

<template>
    <template v-if="isSuccess">
        <nav class="flex h-[76px] flex-nowrap items-center bg-primary !px-5 !py-2 print:hidden lg:!px-[30px]">
            <router-link
                :to="{ name: `home` }"
                class="!mr-5 w-[24px] text-primary-50 hover:text-primary-50 lg:mr-[30px] lg:w-[93px]">
                <InlineSvg
                    :src="logoIcon"
                    class="visible !mt-[-7px] block h-[35px] w-auto lg:invisible lg:hidden" />
                <InlineSvg
                    :src="logo"
                    class="visible !mt-[-7px] hidden h-[35px] w-auto lg:visible lg:block" />
                Helm {{ environment }}
            </router-link>

            <MainNavMobile v-if="mobile" />
            <MainNavMenu v-else />

            <div class="text-primary-50">Welcome, {{ name }}</div>
            <router-link
                :to="{ name: `logout` }"
                class="!mx-2 inline-block flex h-9 items-center whitespace-nowrap rounded-full bg-transparent !px-3 !py-0 text-base font-medium leading-none text-primary-50 transition-colors hover:!bg-primary-50 hover:!text-primary hover:no-underline">
                Logout
            </router-link>
        </nav>

        <div class="flex h-[calc(100vh-76px)] flex-col items-stretch lg:flex-row">
            <SideNavMobile
                v-if="sideNav"
                :key="route.fullPath"
                :menu="sideNav" />
            <SideNavMenu
                v-if="sideNav"
                :key="route.fullPath"
                :menu="sideNav" />

            <slot />
        </div>
    </template>
    <template v-else>
        <div class="flex h-screen items-center justify-center">
            <LoadingSpinner class="h-16" />
            Loading, please wait...
        </div>
    </template>
</template>

<style scoped>
:slotted(div) {
    @apply z-[1] grow overflow-y-auto;
}
</style>
